import Select from 'antd/lib/select';
import Table from 'antd/lib/table';
import { ColumnsType } from 'antd/lib/table';
import { connect } from 'react-redux';

const { Option } = Select;
import * as React from 'react';
import { getReleaseStepFromState } from '../helpers';
import { RootState } from '../reducers/reducers';
import {
    ReleaseStepBetaTestingData,
    ReleaseStepType,
    BetaTester,
    BetaTestingGroup,
    ReleaseStepBetaTesting,
} from '../types';
import { selectStepRun } from '@/selectors/selectors';
import { StepRunComponentProps } from '@/typescriptHelpers';

type testerRow = {
    name: string;
    email: string;
};

const BetaTesters = (props: { testers: BetaTester[]; betaGroups: BetaTestingGroup[] }): JSX.Element => {
    const [selectedTesterGroup, setSelectedTesterGroup] = React.useState('all-testers');

    const tableDataSource = props.testers.map((tester) => {
        const groups = props.betaGroups.filter((betaGroup) => betaGroup.testers?.includes(tester.email));
        const groupsIds = groups.map((group) => group.id);
        return {
            name: tester.firstName + ' ' + tester.lastName,
            email: tester.email,
            groups: ['all-testers', ...groupsIds],
            key: tester.email,
        };
    });

    const tableDataSourceFiltered = tableDataSource.filter((tester) => {
        return selectedTesterGroup === 'all-testers' ? true : tester.groups.includes(selectedTesterGroup);
    });

    const tableColumns: ColumnsType<testerRow> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            defaultSortOrder: 'descend',
            sorter: (a, b) => (a.name > b.name ? 1 : -1),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            defaultSortOrder: 'descend',
            sorter: (a, b) => (a.email > b.email ? 1 : -1),
        },
        // {
        //     title: 'Status',
        //     dataIndex: 'status',
        //     key: 'status',
        //     defaultSortOrder: 'descend',
        //     sorter: (a, b) => (a.status > b.status ? 1 : -1),
        // },
        // {
        //     title: 'Sessions',
        //     dataIndex: 'sessions',
        //     key: 'sessions',
        //     defaultSortOrder: 'descend',
        //     sorter: (a, b) => (a.sessions > b.sessions ? 1 : -1),
        // },
    ];
    return (
        <div style={{ width: '100%' }}>
            <Select
                style={{ marginTop: 16, marginBottom: 32, width: '33%', minWidth: 200 }}
                value={selectedTesterGroup}
                onChange={(value) => setSelectedTesterGroup(value)}
            >
                <Option value={'all-testers'}>All testers</Option>
                {props.betaGroups.map((betaGroup) => {
                    return (
                        <Option key={betaGroup.id} value={betaGroup.id}>
                            {betaGroup.name}
                        </Option>
                    );
                })}
            </Select>
            <Table
                dataSource={tableDataSourceFiltered}
                columns={tableColumns}
                locale={{ emptyText: 'There are no testers in this group' }}
            />
        </div>
    );
};

const mapProps = (
    state: RootState,
    ownProps: {
        releaseId: string;
        releaseStepType: ReleaseStepType;
        stepRunComponentProps: StepRunComponentProps;
    },
) => {
    const { releaseId, releaseStepType, stepRunComponentProps } = ownProps;

    const releaseStep = getReleaseStepFromState(releaseStepType, releaseId, state) as ReleaseStepBetaTesting;

    const stepRunId = stepRunComponentProps?.stepRunId;
    const stepRun = selectStepRun(state, stepRunId);
    const stepData: ReleaseStepBetaTestingData =
        stepRun ? { ...stepRun.data.summaryData, ...stepRun.data.complementaryData } : releaseStep.data;

    const testers = stepData.testers ?? [];
    const betaGroups = stepData.betaGroups ?? [];

    return {
        testers,
        betaGroups,
    };
};

const connector = connect(mapProps);

export default connector(BetaTesters);
